import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';

import './SupplierInfo.scss';

const b = block('supplier-info');

interface SupplierInfoProps {
    supplier: string;
    className?: string;
}

export const SupplierInfo: React.FC<SupplierInfoProps> = ({supplier, className}) => {
    return (
        <div className={`${b('block', className)}`}>
            <Text variant="body-1" className={b('text')}>
                {supplier}
            </Text>
        </div>
    );
};
